// Filename : views/calendar-week.js
define('views/modules/template/edit/calendar/calendar-component/template-calendar-week',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'bootbox',
    //services
    'services/i18n',
    'services/toastr-service',
    // events
    'services/events/calendar-events',
    // Views
    'views/modules/calendar/calendar/calendar-component/calendar-week',
    'views/modules/template/edit/calendar/calendar-component/template-calendar-day',
    // template
    'text!templates/modules/template/edit/calendar/calendar-component/template-calendar-week.html'
], function(
    // Libs
    _, Backbone, Mustache, U, Bootbox,
    //services
    i18n,
    ToastrService,
    // Events
    CalendarEvents,
    // Views
    VCalendarWeek,
    VTemplateCalendarDay,
    // template
    TTemplateCalendarWeek
) {

    var VTemplateCalendarWeek = VCalendarWeek.extend({
        template: TTemplateCalendarWeek,
        dayView: VTemplateCalendarDay,
        dayOptions: {
            displayDate: false
        },

        events: {
            'click #btn-remove-week': 'onRemoveWeekClick'
        },

        render: function() {
            VTemplateCalendarWeek.__super__.render.apply(this, arguments);
            this.$el.append(Mustache.render(this.template, Mustache.getContext()));
        },

        ////////////
        // events //
        ////////////

        onRemoveWeekClick: function() {
            if (this.$('.calendar-item .is-animated').length > 0) {
                ToastrService.error('template:you-cannot-delete-that-week');
                return false;
            }

            if (this.$('.calendar-item').length > 0) {
                Bootbox.confirm({
                    title: i18n.t("Delete template week"),
                    message: i18n.t("messages:message-delete-template-week-containing-item"),
                    onEscape: true,
                    backdrop: true,
                    callback: this.deleteWeek,
                    context: this,
                });
            } else {
                this.deleteWeek(true);
            }
        },

        deleteWeek: function(result) {
            if (result) {
                // Using first model of the collection to trigger the event to get only one listener
                // rather than having a listener for each week
                var weekIsEmpty = this.$('.calendar-item').length === 0;
                
                this.collection.first().trigger('remove:week', this.collection);
                this.remove();
                if (!weekIsEmpty) {
                    CalendarEvents.removeNonEmptyWeek();
                }
            }
        },


    });

    return VTemplateCalendarWeek;

});

